/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Полная модель страны
 * @export
 * @interface GetCountry200ResponseDataCountry
 */
export interface GetCountry200ResponseDataCountry {
  /**
   * UUID страны
   * @type {string}
   * @memberof GetCountry200ResponseDataCountry
   */
  uuid: string
  /**
   * Название страны
   * @type {string}
   * @memberof GetCountry200ResponseDataCountry
   */
  name: string
  /**
   * ISO-код страны
   * @type {string}
   * @memberof GetCountry200ResponseDataCountry
   */
  code: string
  /**
   * Английское название
   * @type {string}
   * @memberof GetCountry200ResponseDataCountry
   */
  nameEng?: string | null
  /**
   * Время создания записи
   * @type {string}
   * @memberof GetCountry200ResponseDataCountry
   */
  createdAt?: string | null
  /**
   * Время обновления записи
   * @type {string}
   * @memberof GetCountry200ResponseDataCountry
   */
  updatedAt?: string | null
}

/**
 * Check if a given object implements the GetCountry200ResponseDataCountry interface.
 */
export function instanceOfGetCountry200ResponseDataCountry(
  value: object
): value is GetCountry200ResponseDataCountry {
  if (!('uuid' in value) || value['uuid'] === undefined) return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('code' in value) || value['code'] === undefined) return false
  return true
}

export function GetCountry200ResponseDataCountryFromJSON(
  json: any
): GetCountry200ResponseDataCountry {
  return GetCountry200ResponseDataCountryFromJSONTyped(json, false)
}

export function GetCountry200ResponseDataCountryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetCountry200ResponseDataCountry {
  if (json == null) {
    return json
  }
  return {
    uuid: json['uuid'],
    name: json['name'],
    code: json['code'],
    nameEng: json['nameEng'] == null ? undefined : json['nameEng'],
    createdAt: json['createdAt'] == null ? undefined : json['createdAt'],
    updatedAt: json['updatedAt'] == null ? undefined : json['updatedAt'],
  }
}

export function GetCountry200ResponseDataCountryToJSON(
  value?: GetCountry200ResponseDataCountry | null
): any {
  if (value == null) {
    return value
  }
  return {
    uuid: value['uuid'],
    name: value['name'],
    code: value['code'],
    nameEng: value['nameEng'],
    createdAt: value['createdAt'],
    updatedAt: value['updatedAt'],
  }
}
